// import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import axios from 'axios';
// import API_BASE_URL from '../../utilities/ApiConfig';

// // Async thunk to send OTP
// export const sendOtp = createAsyncThunk('otp/sendOtp', async ({ mobileNo, pcode }, { rejectWithValue }) => {
//   try {
//     const response = await axios.post(`${API_BASE_URL}/Auth/Send_Otp_mobile?mobileno=${mobileNo}`);

//     if (response.status === 200) {
//       const otpString = response.data?.mobile_otp;
//       const otp = otpString ? JSON.parse(otpString).result : null;

//       if (otp) {
//         return { pcode, otp: String(otp) }; // Store OTP as a string
//       } else {
//         throw new Error('OTP response format is incorrect');
//       }
//     } else {
//       throw new Error('Failed to send OTP');
//     }
//   } catch (error) {
//     return rejectWithValue(error.message);
//   }
// });

// // Slice definition
// const otpSlice = createSlice({
//   name: 'otp',
//   initialState: {},
//   reducers: {
//     setVerified: (state, action) => {
//       const { pcode, verified } = action.payload;
//       if (state[pcode]) {
//         state[pcode].verified = verified;
//       }
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(sendOtp.fulfilled, (state, action) => {
//         const { pcode, otp } = action.payload;
//         state[pcode] = { otp, verified: false }; // Store OTP with initial unverified state
//       })
//       .addCase(sendOtp.rejected, (state, action) => {
//         console.error('OTP sending failed:', action.payload);
//       });
//   },
// });

// export const { setVerified } = otpSlice.actions;
// export default otpSlice.reducer;

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import API_BASE_URL from "../../utilities/ApiConfig";

export const sendOtp = createAsyncThunk(
  "otp/sendOtp",
  async ({ mobileNo, pcode, pdeId }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/Auth/Send_Otp_mobile?mobileno=${mobileNo}`
      );
      if (response.status === 200) {
        const otpString = response.data?.mobile_otp;
        const otp = otpString ? JSON.parse(otpString).result : null;
        if (otp) {
          return { pkey: `${pdeId}_${pcode}`, otp: String(otp) }; // Updated key
        } else {
          throw new Error("OTP response format is incorrect");
        }
      } else {
        throw new Error("Failed to send OTP");
      }
    } catch (error) {
      return rejectWithValue({
        pkey: `${pdeId}_${pcode}`, // Updated key
        message: error.message,
      });
    }
  }
);

const otpSlice = createSlice({
  name: "otp",
  initialState: {},
  reducers: {
    setVerified: (state, action) => {
      const { pkey, verified } = action.payload;
      if (state[pkey]) {
        state[pkey].verified = verified;
      }
    },
    resetOtpState: (state, action) => {
      const { pkey } = action.payload;
      delete state[pkey];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendOtp.pending, (state, action) => {
        const { pdeId, pcode } = action.meta.arg;
        const pkey = `${pdeId}_${pcode}`; // Updated key
        state[pkey] = {
          ...state[pkey],
          loading: true,
          error: null,
        };
      })
      .addCase(sendOtp.fulfilled, (state, action) => {
        const { pkey, otp } = action.payload;
        state[pkey] = {
          otp,
          verified: false,
          loading: false,
          error: null,
        };
      })
      .addCase(sendOtp.rejected, (state, action) => {
        const { pkey, message } = action.payload;
        state[pkey] = {
          ...state[pkey],
          loading: false,
          error: message || "OTP sending failed",
        };
      });
  },
});

export const { setVerified, resetOtpState } = otpSlice.actions;
export default otpSlice.reducer;
